"use client";

import { Header } from "@/components/shared/public";
import { useTranslations } from "next-intl";

const Head = () => {
  const tH = useTranslations("floorPlanDesigns.head");

  return <Header title={tH("title")} />;
};

export default Head;
